var exports = {
  "U": "proLabel__9KCGl0",
};

module.exports = exports;
